<div class="pay-rates">
  <ng-container *ngIf="vm$ | async as vm">
    <div *ngIf="vm.division === division.roi" class="pay-rates__rate-selector">
      <ui-radio-input
        [control]="control"
        [options]="options"
        orientation="horizontal"
      ></ui-radio-input>
    </div>
    <ng-container *ngIf="vm.sections.length > 0; else noResultsFound">
      <div *ngFor="let payRateItem of vm.sections" class="pay-rates__container">
        <div class="pay-rates__content">
          <div class="pay-rates__content__title">
            {{ payRateItem.name ?? 'No title given' }}
          </div>
          <div class="pay-rates__content__wages">
            {{
              payRateItem.minSectionRate
                | currency: vm.currencyCode : 'symbol' : '1.2'
            }}
            -
            {{
              payRateItem.maxSectionRate
                | currency: vm.currencyCode : 'symbol' : '1.2'
            }}
            per hour
          </div>
        </div>
        <div class="pay-rates__content__table">
          <div
            class="pay-rates__content__table__row pay-rates__content__table__header"
          >
            <div>Shift</div>
            <div>Total hourly</div>
            <div>Excl. holiday</div>
            <div>Holiday</div>
          </div>
          <div
            *ngFor="let rate of payRateItem.rates"
            class="pay-rates__content__table__row"
          >
            <div class="description">
              {{ rate.type ?? 'No rate title given' }}
              {{ rate.workingHours ?? 'No working hours given' }}
            </div>
            <div class="cell">
              <div class="timeframe">Total hourly</div>
              <div class="wage">
                {{
                  rate.hourlyPay | currency: vm.currencyCode : 'symbol' : '1.2'
                }}
              </div>
            </div>
            <div class="cell">
              <div class="timeframe">Excl. holiday</div>
              <div class="wage">
                {{
                  rate.excludingHolidayPay
                    | currency: vm.currencyCode : 'symbol' : '1.2'
                }}
              </div>
            </div>
            <div class="cell">
              <div class="timeframe">Holiday</div>
              <div class="wage">
                {{
                  rate.holidayPay | currency: vm.currencyCode : 'symbol' : '1.2'
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div
      *ngIf="vm.payRatesUrl?.standard as payRatesUrl"
      class="pay-rates__content__link"
    >
      <a [href]="payRatesUrl" target="_blank">View All Standard Pay Rates</a>
    </div>
    <div
      *ngIf="vm.payRatesUrl?.specialist as payRatesUrl"
      class="pay-rates__content__link"
    >
      <a [href]="payRatesUrl" target="_blank">View All Specialist Pay Rate</a>
    </div>
    <div
      *ngIf="vm.payRatesUrl?.private as payRatesUrl"
      class="pay-rates__content__link"
    >
      <a [href]="payRatesUrl" target="_blank">View All Private Pay Rates</a>
    </div>
  </ng-container>
</div>

<ng-template #noResultsFound>
  <div class="pay-rates__no-rates-found">No Rates Found</div>
</ng-template>
